var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAccessLimit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.65039C0 6.40775 1.04467 5.40039 2.33333 5.40039H11.6667C12.9553 5.40039 14 6.40775 14 7.65039V15.7504C14 16.993 12.9553 18.0004 11.6667 18.0004H2.33333C1.04467 18.0004 0 16.993 0 15.7504V7.65039ZM4.66667 10.3504C4.66667 9.10775 5.71134 8.10039 7 8.10039C8.28866 8.10039 9.33333 9.10775 9.33333 10.3504C9.33333 10.7296 9.23606 11.0869 9.06426 11.4003C10.0703 12.0452 10.7333 13.1481 10.7333 14.4004C10.7333 14.8974 10.3155 15.3004 9.8 15.3004H4.2C3.68453 15.3004 3.26667 14.8974 3.26667 14.4004C3.26667 13.1481 3.92971 12.0452 4.93574 11.4003C4.76394 11.0869 4.66667 10.7296 4.66667 10.3504Z",
    fill: "#00AABE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3335 4.05C2.3335 1.81325 4.2139 0 6.5335 0H7.46683C9.78643 0 11.6668 1.81325 11.6668 4.05V6.3H9.80016V4.05C9.80016 2.80736 8.75549 1.8 7.46683 1.8H6.5335C5.24483 1.8 4.20016 2.80736 4.20016 4.05V6.3H2.3335V4.05Z",
    fill: "#00AABE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAccessLimit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_access_limit.b5f387d709c5bef66c706b83c9295532.svg";